import React from 'react';
import { Box, Input, Text } from '@chakra-ui/react';
import { colors } from '../../utils/colors';

interface BenefitTypeDetailProps {
  type?: string;
  value?: string;
  onChange: (value: string) => void;
  error?: string;
}

const detailBoxProps = {
  bg: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 10,
  height: '36px',
  px: 4,
  display: 'flex',
  alignItems: 'center',
};

const DETAIL_MIN_HEIGHT = '57px';

const BenefitTypeDetail: React.FC<BenefitTypeDetailProps> = ({
  type,
  value,
  onChange,
  error,
}) => {
  if (type === 'discount') {
    const percentage = value ? value.replace('%', '') : '';

    return (
      <Box minHeight={DETAIL_MIN_HEIGHT}>
        <Box
          {...detailBoxProps}
          width={'160px'}
          gap={2}
          justifyContent={'center'}>
          <Input
            value={percentage}
            onChange={event => {
              const digitsOnly = event.target.value.replace(/[^0-9]/g, '');
              if (digitsOnly === '') {
                onChange('');
                return;
              }
              const clamped = Math.min(100, Number(digitsOnly));
              onChange(`${clamped}%`);
            }}
            onBlur={() => {
              const clamped = Math.max(0, Math.min(100, Number(percentage) || 0));
              onChange(`${clamped}%`);
            }}
            type={'text'}
            inputMode={'numeric'}
            variant={'unstyled'}
            height={'100%'}
            lineHeight={'36px'}
            px={0}
            py={0}
            width={'40px'}
            flexShrink={0}
            textAlign={'right'}
            fontSize={16}
            fontWeight={700}
            color={'#fff'}
          />
          <Text fontWeight={700} color={'#fff'} fontSize={16} flexShrink={0}>
            %
          </Text>
        </Box>
        <Text color={'rgba(255,255,255,0.35)'} fontSize={13} mt={1}>
          sobre el precio del producto
        </Text>
        {error && (
          <Text fontSize={12} color={colors.red.main} mt={1}>
            {error}
          </Text>
        )}
      </Box>
    );
  }

  if (type === 'promo') {
    return (
      <Box minHeight={DETAIL_MIN_HEIGHT}>
        <Box {...detailBoxProps} width={'160px'} px={0}>
          <Input
            value={value ?? ''}
            onChange={event => onChange(event.target.value)}
            variant={'unstyled'}
            placeholder={'Ej: 2x1'}
            height={'100%'}
            width={'100%'}
            lineHeight={'36px'}
            px={0}
            py={0}
            textAlign={'center'}
            fontSize={16}
            color={'#fff'}
            _placeholder={{ color: 'rgba(255,255,255,0.3)' }}
          />
        </Box>
        {error && (
          <Text fontSize={12} color={colors.red.main} mt={1}>
            {error}
          </Text>
        )}
      </Box>
    );
  }

  return <Box minHeight={DETAIL_MIN_HEIGHT} />;
};

export default BenefitTypeDetail;
